'use client';

import { Button, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { signIn } from 'next-auth/react';

import { WelcomePageWrapper } from '@/app/(blank-layout-pages)/welcomePageWrapper';

const LoginV1 = () => {
  return (
    <WelcomePageWrapper>
      <Stack
        sx={{
          gap: '40px',
          overflow: 'hidden',
          width: '680px',
          maxWidth: '100%',
        }}
      >
        <Typography
          variant='h1'
          sx={{ maxWidth: '540px', wordWrap: 'break-word' }}
        >
          Log in to your account
        </Typography>
        <Button
          variant='outlined'
          data-testid='login-google-button'
          startIcon={
            <Image
              src='/statics/images/logos/google.png'
              alt='Google'
              width={22}
              height={22}
            />
          }
          sx={{
            alignSelf: 'flex-start',
            color: 'var(--mui-palette-text-primary)',
            '& .MuiButton-startIcon': { marginInlineEnd: '12px' },
          }}
          onClick={() => void signIn('google')}
        >
          Sign in with Google
        </Button>
      </Stack>
    </WelcomePageWrapper>
  );
};

export { LoginV1 };
